import React, { useEffect } from 'react';
import { Checkbox, ListItemText, Menu, MenuItem } from '@mui/material';
import { COMPANY_LIST_DETAILS } from '../../contants';
import { useLocation, useNavigate } from 'react-router-dom';
import { FilterBtn } from '../FilterBtn';

/**
 * FilterByCompany
 *
 * A component that renders a filter button and a dropdown menu to filter items by company.
 *
 * @param {string} text - Text for the filter button.
//  * @param {Array} companyList - List of companies to display in the dropdown, each with an `id`, `name`, and `checked` property.
 * @param {function} checkedHandler - Function to handle checkbox changes for each company.
 * @param {object} btnSx - Custom styles for the filter button.
 * @param {object} menuSx - Custom styles for the dropdown menu.
 *
 * @returns {JSX.Element} - A filter button with an attached dropdown menu for selecting companies.
 */

function FilterByCompany({
    text = 'Filter by company',
    // companyList = [],
    // checkedHandler = () => {},
    onChange = () => {},
    selectedCompanyList = [],
    btnSx = {},
    menuSx = {},
    hideHousehold = false,
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [companyList, setCompanyList] = React.useState([...COMPANY_LIST_DETAILS(hideHousehold)]);
    const open = Boolean(anchorEl);

    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (value) => {
        setAnchorEl(null);
    };

    const checkedHandler = (checked, newCompany) => {
        const newFilteredCompanyList = companyList.map((cItem) => {
            if (cItem.id === newCompany.id) {
                const newValue = {
                    ...cItem,
                    checked: checked,
                };
                return newValue;
            }
            return cItem;
        });

        const selectedCompanyList = newFilteredCompanyList.filter((cItem) => cItem.checked);

        // Create URSearchParams
        const searchParams = new URLSearchParams(location.search);
        const filters = searchParams.getAll('filter'); // Returns an array

        if (filters.find((cCompanyId) => cCompanyId === newCompany.id)) {
            searchParams.delete('filter', newCompany.id || '');
            navigate(`${location.pathname}?${searchParams.toString()}`);
        } else {
            searchParams.append('filter', newCompany.id || '');
            navigate(`${location.pathname}?${searchParams.toString()}`);
        }

        setCompanyList(newFilteredCompanyList);
        onChange(selectedCompanyList);
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        // Get all 'filter' values
        const filters = searchParams.getAll('filter'); // Returns an array

        // get company list with selected and non selected items
        const updatedList = companyList.map((currentCompany) => {
            if (filters.find((id) => id === currentCompany.id)) {
                const newValue = {
                    ...currentCompany,
                    checked: true,
                };

                return newValue;
            } else {
                const newValue = {
                    ...currentCompany,
                    checked: false,
                };

                return newValue;
            }
        });

        const selectedCompanyList = updatedList.filter((cItem) => cItem.checked); // get company list with selected items

        setCompanyList(updatedList);
        onChange(selectedCompanyList);
    }, [location.search]);

    useEffect(() => {
        // get company list with selected and non selected items
        const updatedList = companyList.map((currentCompany) => {
            if (selectedCompanyList.find((c) => c.id === currentCompany.id)) {
                const newValue = {
                    ...currentCompany,
                    checked: true,
                };

                return newValue;
            } else {
                const newValue = {
                    ...currentCompany,
                    checked: false,
                };

                return newValue;
            }
        });

        setCompanyList(updatedList);
    }, [selectedCompanyList]);

    return (
        <>
            <FilterBtn text={text} handleClick={handleClick} sx={{ ...btnSx }} />
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                sx={{
                    '& .MuiPaper-root': {
                        // width: anchorEl?.offsetWidth || '165px',
                    },

                    ...menuSx,
                }}
            >
                {companyList.map((cCompany) => (
                    <MenuItem
                        key={cCompany.id}
                        onClick={() => checkedHandler(!cCompany.checked, cCompany)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                checkedHandler(!cCompany.checked, cCompany);
                            }
                        }}
                    >
                        <Checkbox checked={cCompany.checked} onChange={(event) => checkedHandler(event.target.checked, cCompany)} />
                        <ListItemText primary={cCompany.name} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default FilterByCompany;
